interface StatusCircleProps {
  color: string;
  size: string;
  sx?: React.CSSProperties;
}

const StatusCircle = (props: StatusCircleProps) => {
  //   console.log('StatusCircle status', status);
  const { color, size, sx } = props;

  return (
    <div
      style={{
        paddingRight: '6px',
      }}
    >
      <div
        style={{
          backgroundColor: color,
          width: size,
          height: size,
          borderRadius: '50%', // Makes it a circle
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          ...sx,
          // Add any other styles like border, boxShadow, etc.
        }}
      >
        {/* You can add an icon or abbreviation here */}
      </div>
    </div>
  );
};

export default StatusCircle;
